import {
  SET_ACTIVE_ACCOUNT
} from '../actions';

const initialState = {app_meta_data: {}, addresses: [], contacts: [], locations: []}
export default function (state = initialState, action) {

  switch(action.type) {
    case SET_ACTIVE_ACCOUNT:
      return action.payload;

    default:
      return state;
  }
}